import {assert} from 'assert-ts';
import type {AgentSubType} from 'types';
import type {EditorMode} from 'editors/types';
import {useLocalization} from 'localization';
import type {AgentState} from 'services/agent/reducer/agentReducer';
import {formatNameVariantValue} from 'schema/preview/functions';

export const useAgentTitle = (
  mode: EditorMode,
  agent: AgentState | undefined,
  agentType: AgentSubType | undefined,
) => {
  const {t} = useLocalization();
  if (mode === 'register') {
    return t(
      `wizard.agent.${assert(
        agentType,
        'useAgentTitle: type required',
      )}.register.title`,
    );
  }

  return agent && agent.status === 'Loaded'
    ? formatNameVariantValue(
        agent.data.nameVariants[0],
        agent.data.agentType,
        'excludeId',
      )
    : '';
};
